import {
  createDataReducer,
  getDataReducerInitialState,
} from "@ea/shared_components/redux/reducers/common.data.reducer";

import { Kpi } from "@ea/shared_types/types";
import { moduleActions } from "./kpis.actions";

const initialState = {
  ...getDataReducerInitialState<Kpi>(),
};

export type KpisReducer = typeof initialState;

const dataReducer = createDataReducer<Kpi>({
  ...moduleActions.table,
  ...moduleActions.data,
});

export const reducer = dataReducer(initialState);
